import styled from '@emotion/styled'

export const Wrapper = styled('div')(({ theme }) => ({
  backgroundColor: 'rgb(229, 229, 229)',
  borderRadius: theme.borderRadius.giga,
  padding: theme.spacings.giga
}))

export const Title = styled('label')({
  fontWeight: 'bold',
  fontSize: '1rem',
  color: '#166534',
  display: 'block',
  marginBottom: '.5rem'
})

export const List = styled('ul')({
  paddingLeft: '.75rem',
  margin: '.5rem 0 0',
  listStyleType: 'disc !important'
})

export const ListItem = styled('li')({
  lineHeight: '1.5rem',
  fontSize: '.875rem',
  marginBottom: '.5rem'
})

export const Section = styled('div')({
  marginBottom: '1rem'
})
